import queryKeys from '@/constants/queryKeys';
import { markAllNotificationsAsRead } from '@/services/api/requests/notifications';
import { useMutation } from '@tanstack/react-query';

const useReadAllNotifications = (onSuccess?: () => void) => {
  const { mutate, data, isError, error, isPending } = useMutation({
    mutationKey: [queryKeys.notifications.toggleReadMultiple],
    mutationFn: async () => {
      const response = await markAllNotificationsAsRead();

      return response;
    },
    onSuccess,
  });

  return { mutate, data, isError, error, isPending };
};

export default useReadAllNotifications;
